export const DarkTitlebarData = {
  "jcr:primaryType": "cq:PageContent",
  "jcr:createdBy": "admin",
  "title": "dark-title-bar",
  "cq:template": "/apps/gdocs/templates/page-create-case",
  "jcr:language": "en",
  "cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
  "jcr:created": "Wed May 09 2018 11:22:21 GMT+0000",
  "cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
  "cq:cloudserviceconfigs": [
    "[]"
  ],
  "sling:resourceType": "gdocs/components/pages/create-case",
  "cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
  "cq:lastModifiedBy": "admin",
  "par": {
    "jcr:primaryType": "nt:unstructured",
    "sling:resourceType": "wcm/foundation/components/parsys",
    "static_text_darkTitleBar": {
      "jcr:primaryType": "nt:unstructured",
      "exitCase": "~{UI.46BB8604}~",
      "others": "~{UI.33679A04}~",
      "jcr:createdBy": "admin",
      "exitAdmin": "~{UI.AB075E39}~",
      "others": "~{UI.33679A04}~",
      "status": "~{UI.3967AF56}~",
      "backToAdmin": "~{UI.8EC4FF1F}~",
      "backToCase": "~{UI.8EC4C229}~",
      "yourCase": "~{UI.BB119A64}~",
      "jcr:created": "Sat Dec 31 2016 23:00:01 GMT+0000",
      "case": "~{UI.68F1ABE4}~",
      "glcm": "~{UI.A574CCF2}~",
      "hsbc": "~{UI.A574CCF2}~",
      "sow": "~{UI.7DFF666C}~",
      "CaseStatusapi": "product/taxonomies/case-status",
      "caseList": "~{UI.65A15C46}~",
      "admin": "~{UI.0B30A14F}~",
      "owner": "~{UI.A67568BB}~",
      "groupMember": "~{UI.B11FDA48}~",
      "created": "~{UI.9F647975}~",
      "addGroupMember": "~{UI.6A71F03E}~",
      "sling:resourceType": "gdocs/components/content/static_text",
      "welcome": "~{UI.09DCC43D}~",
      "createCase": "~{UI.1F43A822}~",
      "documentation": "~{UI.73384A44}~",
      "hsbcProfile": "~{UI.60EB3338}~",
      "activation": "~{UI.E7E938FE}~",
      "editModeWarning": "~{UI.79A975EE}~",
      "createPassword": "~{UI.705ADB35}~"
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/darkTitlebar/json_dark-title-bar.js